
// ------------------------------------
// Constants
// ------------------------------------
import axios from 'axios'
// import Notifications from 'react-notification-system-redux'
import { protocol, origin } from '../../../store/addons'

export const GET_DATA = 'GET_DATA'
export const GET_BASELINE_DATA = 'GET_BASELINE_DATA'

// ------------------------------------
// Actions
// ------------------------------------

const getDataAction = (data = undefined) => {
  return {
    type: GET_DATA,
    data: data
  }
}

const getBaselineDataAction = (data = undefined) => {
  return {
    type: GET_BASELINE_DATA,
    data: data
  }
}

export const getData = (params) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      let highRiskEmployedTable = [50, 75, 'no intervention']
      let populationEmployedTable = [10, 20, 30, 40, 50]
      let numberWorkersPerCommunityCenterTable = [3, 5, 1]
      let maleRatioTable = [55, 50, 45]
      let cpoTable = [25, 50, 0]
      let criminalHistoryPercentTable = [2, 5, 10, 20]
      /* eslint-disable */
      if(params.type === 'base') {
        Promise.all([
          axios.get(`${protocol}//${origin}/api/step/terrorist?highRiskEmployed=${highRiskEmployedTable[params.highRiskEmployed]}&populationEmployed=${populationEmployedTable[params.populationEmployed]}&numberWorkersPerCommunityCenter=${numberWorkersPerCommunityCenterTable[params.numberWorkersPerCommunityCenter]}&maleRatio=${maleRatioTable[params.maleRatio]}&cpo=${cpoTable[params.cpo]}&criminalHistoryPercent=${criminalHistoryPercentTable[params.criminalHistoryPercent]}`,
          {headers: {'Access-Control-Allow-Origin': '*'}}),
          axios.get(`${protocol}//${origin}/api/step/terrorist?highRiskEmployed=no intervention&populationEmployed=${populationEmployedTable[params.populationEmployed]}&numberWorkersPerCommunityCenter=1&maleRatio=${maleRatioTable[params.maleRatio]}&cpo=0&criminalHistoryPercent=${criminalHistoryPercentTable[params.criminalHistoryPercent]}`,
          {headers: {'Access-Control-Allow-Origin': '*'}})
        ])
      /* eslint-enable */
      .then(([intervention, baseline]) => {
        let data = [...intervention.data]
        intervention.data.map((item, i) => {
          Object.keys(item).map(step => {
            data[i] && (data[i][step + 'b'] = baseline.data[i][step])
          })
        })
        dispatch(getDataAction(data))
        resolve()
      })
        .catch((error) => {
          console.log(error)
          resolve()
        })
      } else {
        Promise.all([
          axios.get(`${protocol}//${origin}/api/step/terrorist/results?type=${params.highRiskEmployed}`,
          { headers: { 'Access-Control-Allow-Origin': '*' } }),
          axios.get(`${protocol}//${origin}/api/step/terrorist/results?type=baseline`,
          { headers: { 'Access-Control-Allow-Origin': '*' } })])
          .then(([intervention, baseline]) => {
              let data = [...intervention.data]
              baseline.data.map((item, i) => {
                Object.keys(item).map(step => {
                  data[i] && (data[i][step + 'b'] = baseline.data[i][step])
                })
              })

              dispatch(getDataAction(data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
      }
    })
  }
}

export const getBaselineData = (params) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      let highRiskEmployedTable = [50, 75]
      let populationEmployedTable = [10, 20, 30, 40, 50]
      let numberWorkersPerCommunityCenterTable = [1]
      let maleRatioTable = [50, 45]
      let cpoTable = [25, 50, 0]
      let criminalHistoryPercentTable = [2, 5, 10, 20]
      /* eslint-disable */
      if(params.type === 'base') {
      axios.get(`${protocol}//${origin}/api/step/terrorist?highRiskEmployed=${highRiskEmployedTable[params.highRiskEmployed]}&populationEmployed=${populationEmployedTable[params.populationEmployed]}&numberWorkersPerCommunityCenter=${numberWorkersPerCommunityCenterTable[params.numberWorkersPerCommunityCenter]}&maleRatio=${maleRatioTable[params.maleRatio]}&cpo=${cpoTable[params.cpo]}&criminalHistoryPercent=${criminalHistoryPercentTable[params.criminalHistoryPercent]}`,
      {headers: {'Access-Control-Allow-Origin': '*'}})
      /* eslint-enable */
      .then((json) => {
          dispatch(getBaselineDataAction(json.data))
          resolve()
        })
        .catch((error) => {
          console.log(error)
          resolve()
        })
      } else {
        axios.get(`${protocol}//${origin}/api/step/terrorist/results?type=baseline`,
          { headers: { 'Access-Control-Allow-Origin': '*' } })
          .then((json) => {
            let data = []
            json.data.map((item, i) => {
              data.push({})
              Object.keys(item).map(step => {
                data[i][step + 'b'] = json.data[i][step]
              })
            })
              dispatch(getBaselineDataAction(data))
              resolve()
            })
            .catch((error) => {
              console.log(error)
              resolve()
            })
      }
    })
  }
}

export const actions = { getData, getBaselineData }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [GET_DATA]: (state, action) => {
    return {
      ...state,
      data: action.data
    }
  },
  [GET_BASELINE_DATA]: (state, action) => {
    return {
      ...state,
      baselineData: action.data
    }
  }
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  data: [],
  baselineData: []
}

export default function chartReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/components/ChartsComponent/modules/chartscomponent.js